import CancelBookingModal from "../Components/CancelBookingModal";
import { baseUrl } from "../utilities/configurations";
import { useNavigate } from "react-router-dom";
import apiRequest from "../utilities/request";
import toast from "react-hot-toast";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";

const ConsultDoctorContext = createContext();

export function useConsultDoctorContext() {
  return useContext(ConsultDoctorContext);
}

export function ConsultDoctorProvider(props) {
  const [filteredDoctorsBySearch, setFilteredDoctorsBySearch] = useState(); //Filtered Doctors by Search
  const [selectedSpecialization, setSelectedSpecialization] = useState(null);
  const [selectedDoctorBySearch, setSelectedDoctorBySearch] = useState(); //selected doctor if booking via preferred doctor
  const [searchSpecializationByDoctor, setSearchSpecializationByDoctor] =
    useState(); //specialization
  const [allDoctorsFromBranch, setAllDoctorsFromBranch] = useState([]); //all doctors from a selected branch
  const [searchBranchResults, setSearchBranchResults] = useState([]);
  const [specializationsData, setSpecializationsData] = useState([]); //data of all specializations from clinic
  const [searchDoctorResults, setSearchDoctorResults] = useState(); //search results
  const [showDoctorsModal, setShowDoctorsModal] = useState(false);
  const [toSearchByDoctor, setToSearchByDoctor] = useState(false); // Book via Search Doctor
  const [allSpecializations, setAllSpecializations] = useState(); // all specialization from a selected branch
  const [selectedClinic, setSelectedClinic] = useState({});
  const [displayAlert, setDisplayAlert] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [branchAddress, setBranchAddress] = useState("");
  const [allDoctorsData, setAllDoctorsData] = useState();
  const [selectedDoctor, setSelectedDoctor] = useState();
  const [searchBranch, setSearchBranch] = useState("");
  const [searchDoctor, setSearchDoctor] = useState(); //search by doctor's name
  const [selectedTime, setSelectedTime] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [clinicData, setClinicData] = useState([]);
  const [doctorsData, setDoctorsData] = useState([]); //data of all doctors from specialization
  const [notes, setNotes] = useState("");
  const [loadState, setLoadState] = useState("");
  const [recentConsultations, setRecentConsultations] = useState([]);
  const [preferredDoctors, setPreferredDoctors] = useState([]);
  const [showSubmissionError, setShowSubmissionError] = useState(false);
  const [submissionErrorMsg, setSubmissionErrorMsg] = useState("");
  const [showSuccessSaveModal, setShowSuccessSaveModal] = useState(false);
  const [showSaveFailedModal, setShowSaveFailedModal] = useState(false);
  const [isGetSpecialization, setIsGetSpecialization] = useState(false);
  const [preferredDoctor, setPreferredDoctor] = useState(null);
  const [previewScreen, setPreviewScreen] = useState("");
  const [consultLoadState, setConsultLoadState] = useState("");
  const [prefDocsLoadState, setPrefDocsLoadState] = useState("");
  const [pccLoadState, setPccLoadState] = useState("");
  const [physicians, setPhysicians] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);

  const navigate = useNavigate();

  const [
    selectedDoctorBySearchAvailableTime,
    setSelectedDoctorBySearchAvailableTime,
  ] = useState();

  const [
    selectedDoctorBySearchAvailableDate,
    setSelectedDoctorBySearchAvailableDate,
  ] = useState();

  const [month, setMonth] = useState(dayjs().format("MM"));
  const [year, setYear] = useState(dayjs().year());

  useEffect(() => {
    if (!selectedPolicy) {
      navigate("/consult-doctor/choose-policy", { replace: true });
    }
  }, []);

  useEffect(()=>{
    if(selectedClinic && isGetSpecialization){
      setIsGetSpecialization(false);
      getSpecialization();
    }
  },[selectedClinic, isGetSpecialization])

  const filterConsultations = (data) => {
    let arr = data || [];
    arr = arr.filter((e) => !!e.location);
    setRecentConsultations(arr);
  };

  const getRecentConsultations = async (params, state) => {
    try {
      setConsultLoadState(state || "load");
      const res = await apiRequest(
        baseUrl +
          `/consult/recent-consultations?cardNo=${selectedPolicy?.cardNo}${params}`,
        "GET"
      );
      if (!res.error) {
        filterConsultations(res.data);
        setConsultLoadState("load success");
      } else if (res.status >= 500) {
        setConsultLoadState("ISE");
      } else {
        setConsultLoadState("load failed");
      }
    } catch (error) {
      setConsultLoadState("timeout");
    }
  };

  const getPreferredDoctors = async (params, state) => {
    try {
      setPrefDocsLoadState(state || "load");
      const res = await apiRequest(
        baseUrl +
          `/consult/preferred-doctors?cardNo=${selectedPolicy?.cardNo}${params}`,
        "GET"
      );
      if (!res.error) {
        setPreferredDoctors(res.data || []);
        setPrefDocsLoadState("load success");
      } else if (res.status >= 500) {
        setPrefDocsLoadState("ISE");
      } else {
        setPrefDocsLoadState("load failed");
      }
    } catch (error) {
      setPrefDocsLoadState("timeout");
    }
  };

  const getSpecialization = async (state) => {
    setLoadState(state || "get specializations");
    try {
      const res = await apiRequest(
        baseUrl +
          `/consult/specializations?providerCode=${selectedClinic.providerCode}&cardNo=${selectedPolicy?.cardNo}`,
        "GET"
      );
      if (!res.error) {
        let spData = res.data.filter((item) =>
          item.name.toLowerCase().includes("consultation")
        );
        setSpecializationsData(spData);
        //if clicked from preferred doctor, select specialization based on saved consultation
        if (preferredDoctor) {
          mapSpecializationAndDoctor(spData);
        } else {
          setLoadState("get specializations success");
        }
      } else if (res.status >= 500) {
        setLoadState("get specializations ISE");
      } else {
        setLoadState("get specializations failed");
      }
    } catch (error) {
      console.log(error);
      setLoadState("get specializations timeout");
    }
  };

  const mapPhysician = (doctors) => {
    let index = doctors.findIndex((e) => {
      return e.id === preferredDoctor.physicianId;
    });
    if (index >= 0) {
      setSelectedDoctorBySearch(doctors[index]);
      setToSearchByDoctor(true);
    }
    setLoadState("get specializations success");
  };

  const mapSpecializationAndDoctor = async (data) => {
    let index = data.findIndex((e) => {
      return e.id === preferredDoctor.specializationId;
    });
    if (index >= 0) {
      setSelectedSpecialization(data[index]);
      setSelectedDate(null);
      setDoctorsData([]);
      try {
        const res = await apiRequest(
          `${baseUrl}/consult/physicians?specializationId=${data[index].id}`,
          "GET"
        );
        if (!res.error) {
          const doctorsWithSpecialization = res.data
            .map((doctor) => ({
              ...doctor,
              specializationId: data[index].id, // Add the specialization ID to each doctor object
              specializationName: data[index].name, // Add the specialization name to each doctor object
            }))
            .filter((item) =>
              item.specializationName.toLowerCase().includes("consultation")
            );
          mapPhysician(doctorsWithSpecialization);
        } else if (res.status >= 500) {
          setLoadState("get specializations ISE");
        } else {
          setLoadState("get specializations failed");
        }
      } catch (error) {
        setLoadState("get specializations timeout");
      }
    }
  };

  const retrieveClinics = async (state) => {
    try {
      setPccLoadState(state || "load");
      const res = await apiRequest(baseUrl + `/consult/providers`, "GET");
      if (!res.error) {
        setPccLoadState("load success");
        setClinicData(res.data || []);
      } else if (res.status >= 500) {
        setPccLoadState("ISE");
      } else {
        setPccLoadState("load failed");
      }
    } catch (error) {
      setPccLoadState("timeout");
    }
  };

  function convertToStandardTime(militaryTime) {
    const [hours, minutes] = militaryTime.split(":");
    let hoursNum = parseInt(hours, 10);
    const period = hoursNum >= 12 ? "PM" : "AM";
    hoursNum = hoursNum % 12 || 12;
    return `${hoursNum}:${minutes} ${period}`;
  }
  let utc = require("dayjs/plugin/utc");
  let timezone = require("dayjs/plugin/timezone");
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const submissionInProgress = useRef(false);

  function disableButton(id) {
    let btn = document.getElementById(id);
    if (btn) {
      btn.setAttribute("disabled", true);
    }
  }

  function enableButton(id) {
    let btn = document.getElementById(id);
    if (btn) {
      btn.setAttribute("disabled", false);
    }
  }

  const handleSubmit = async () => {
    if (submissionInProgress.current) return;
    try {
      disableButton("consultSubmitButton");
      setIsLoading(true);
      submissionInProgress.current = true;
      const response = await apiRequest(
        baseUrl + "/consult/appointment",
        "POST",
        {
          dateTime: dayjs(
            `${dayjs(selectedDate).format("YYYY-MM-DD")} ${selectedTime}`
          )
            .tz("Asia/Manila")
            .format(),
          specializationId: toSearchByDoctor
            ? selectedDoctorBySearch?.specializationId
            : selectedSpecialization?.id,
          physicianId: toSearchByDoctor
            ? selectedDoctorBySearch?.id
            : selectedDoctor?.id,
          cardNo: selectedPolicy?.cardNo,
          corpCode: selectedPolicy?.corpCode,
          notes: notes,
        }
      );
      if (response.status === true) {
        enableButton("consultSubmitButton");
        setIsLoading(false);
        submissionInProgress.current = false;
        navigate("/consult-doctor/success", { replace: true });
      } else {
        setSubmissionErrorMsg(
          "Oops! It seems like your selected date/timeslot is already taken."
        );
        enableButton("consultSubmitButton");
        setIsLoading(false);
        submissionInProgress.current = false;
        setShowSubmissionError(true);
      }
    } catch (error) {
      enableButton("consultSubmitButton");
      setIsLoading(false);
      submissionInProgress.current = false;
      console.log(error);
    }
  };

  const resetStates = () => {
    setSelectedPolicy(null);
    setSelectedClinic([]);
    setSelectedDoctor("");
    setSearchBranch("");
    setSearchBranchResults([]);
    setSelectedSpecialization(null);
    setNotes("");
  };

  const handleSaveDoctor = async () => {
    setLoadState("save");
    disableButton("saveDoctorBtn");
    const res = await apiRequest(
      baseUrl + `/consult/add-preferred-doctor`,
      "POST",
      {
        cardNo: selectedPolicy?.cardNo,
        physicianId: toSearchByDoctor
          ? selectedDoctorBySearch?.id
          : selectedDoctor?.id,
      }
    );
    if (!res.error) {
      setShowSuccessSaveModal(res.status);
      setShowSaveFailedModal(!res.status);
      setLoadState("save success");
      enableButton("saveDoctorBtn");
    } else {
      toast.error("Save failed.");
      setLoadState("save failed");
      enableButton("saveDoctorBtn");
    }
  };

  const handleBack = (e) => {
    navigate(-1);
  };

  const handleCancel = () => {
    setSearchSpecializationByDoctor();
    setSelectedSpecialization(null);
    setSelectedDoctorBySearch(null);
    setToSearchByDoctor(false);
    setSearchBranchResults([]);
    setDisplayAlert(false);
    setSelectedClinic([]);
    setSelectedDoctor("");
    setSelectedPolicy(null);
    setSearchBranch("");
    setSelectedDate();
    setNotes("");
    navigate("/home", { replace: true });
  };

  const handleProceedWithPreferredDoc = (item) => {
    setPreferredDoctor(item);
    let index = clinicData.findIndex((e) => {
      return e.providerCode === item.providerCode;
    });
    if (index >= 0) {
      setSelectedClinic(clinicData[index]);
      navigate("/consult-doctor/choose-date-time");
      setIsGetSpecialization(true);
    }
  };

  const handleProceedWithRecentConsult = (item) => {
    let index = clinicData.findIndex((e) => {
      return e.providerCode === item.providerCode;
    });
    if (index >= 0) {
      setSelectedClinic(clinicData[index]);
      navigate("/consult-doctor/choose-date-time");
      setIsGetSpecialization(true);
    }
  };

  const data = useMemo(
    () => ({
      setSelectedDoctorBySearchAvailableDate,
      setSelectedDoctorBySearchAvailableTime,
      setSearchSpecializationByDoctor,
      handleProceedWithRecentConsult,
      handleProceedWithPreferredDoc,
      setFilteredDoctorsBySearch,
      setSelectedSpecialization,
      setSelectedDoctorBySearch,
      setAllDoctorsFromBranch,
      setShowSuccessSaveModal,
      setSearchBranchResults,
      setSearchDoctorResults,
      setSpecializationsData,
      setShowSubmissionError,
      getRecentConsultations,
      setShowSaveFailedModal,
      setSubmissionErrorMsg,
      setAllSpecializations,
      convertToStandardTime,
      getPreferredDoctors,
      setPreferredDoctors,
      setToSearchByDoctor,
      setShowDoctorsModal,
      setPreferredDoctor,
      getSpecialization,
      setSelectedClinic,
      setAvailableDates,
      setSelectedDoctor,
      setSelectedPolicy,
      setAllDoctorsData,
      setBranchAddress,
      handleSaveDoctor,
      setPreviewScreen,
      setSearchDoctor,
      setSelectedDate,
      setSelectedTime,
      setSearchBranch,
      setDisplayAlert,
      setPccLoadState,
      retrieveClinics,
      setDoctorsData,
      setPhysicians,
      setClinicData,
      setIsLoading,
      handleSubmit,
      setLoadState,
      handleCancel,
      resetStates,
      handleBack,
      setMonth,
      navigate,
      setNotes,
      setYear,

      selectedDoctorBySearchAvailableDate,
      selectedDoctorBySearchAvailableTime,
      searchSpecializationByDoctor,
      filteredDoctorsBySearch,
      selectedDoctorBySearch,
      selectedSpecialization,
      allDoctorsFromBranch,
      showSuccessSaveModal,
      showSaveFailedModal,
      searchDoctorResults,
      specializationsData,
      searchBranchResults,
      showSubmissionError,
      recentConsultations,
      submissionErrorMsg,
      allSpecializations,
      prefDocsLoadState,
      toSearchByDoctor,
      showDoctorsModal,
      preferredDoctors,
      consultLoadState,
      preferredDoctor,
      selectedPolicy,
      selectedClinic,
      selectedDoctor,
      allDoctorsData,
      availableDates,
      branchAddress,
      previewScreen,
      searchDoctor,
      searchBranch,
      displayAlert,
      selectedTime,
      pccLoadState,
      selectedDate,
      doctorsData,
      physicians,
      clinicData,
      isLoading,
      loadState,
      month,
      notes,
      year,
    }),
    [
      selectedDoctorBySearchAvailableDate,
      selectedDoctorBySearchAvailableTime,
      searchSpecializationByDoctor,
      filteredDoctorsBySearch,
      selectedDoctorBySearch,
      selectedSpecialization,
      allDoctorsFromBranch,
      showSuccessSaveModal,
      showSaveFailedModal,
      searchDoctorResults,
      specializationsData,
      searchBranchResults,
      showSubmissionError,
      recentConsultations,
      submissionErrorMsg,
      allSpecializations,
      prefDocsLoadState,
      toSearchByDoctor,
      showDoctorsModal,
      preferredDoctors,
      consultLoadState,
      preferredDoctor,
      selectedPolicy,
      selectedClinic,
      selectedDoctor,
      allDoctorsData,
      availableDates,
      branchAddress,
      previewScreen,
      searchDoctor,
      searchBranch,
      displayAlert,
      selectedTime,
      selectedDate,
      pccLoadState,
      doctorsData,
      physicians,
      clinicData,
      isLoading,
      loadState,
      month,
      notes,
      year,
    ]
  );

  return (
    <ConsultDoctorContext.Provider value={data}>
      {props.children}
      <CancelBookingModal
        open={displayAlert}
        onClose={() => setDisplayAlert(false)}
        onCancel={handleCancel}
        title={"doctor consultation"}
      />
    </ConsultDoctorContext.Provider>
  );
}

ConsultDoctorProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
